import React from 'react';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { ListItem } from '../../../../../CommonComponents/OPL/List/ListItem';
import { BrowserHeaderActionsLoading } from '../../BrowserHeaderActions.loading';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
} from '../../../../../CommonComponents/OPL/Menu/Menu';
import { useFidelityTokenId } from '../../../../hooks/useFidelityTokenId';
import { toast } from '../../../../../CommonComponents/OPL/Toast/Toast';
import { useDocumentVaultContext } from '../../../../context/useDocumentVaultContext';
import { useNavigate } from '../../../../hooks/useNavigate';
import { useFidelityAvailableUsersListQuery } from '../../../../api/useFidelityAvailableUsersQuery';

export const FidelityActions = () => {
  const { selectedEntity, setSelectedEntity } = useDocumentVaultContext();

  const { data, isLoading } = useFidelityAvailableUsersListQuery();

  const { getCurrentTokenId, setCurrentTokenId } = useFidelityTokenId();

  const currentTokenId = getCurrentTokenId();

  const navigate = useNavigate();

  if (isLoading) {
    return <BrowserHeaderActionsLoading />;
  }

  if (!data || !selectedEntity) {
    return null;
  }

  return (
    <>
      <Menu>
        <MenuTrigger>
          <Button leftIcon="far fa-exchange" variant="subtleActive">
            Switch Household Member
          </Button>
        </MenuTrigger>

        <MenuContent align="end">
          {data.map(({ name, id }) => (
            <MenuItem
              key={name}
              onSelect={() => {
                if (id === currentTokenId) {
                  return;
                }

                setCurrentTokenId(id);

                navigate({
                  path: encodeURIComponent(selectedEntity.path),
                  providerType: selectedEntity.providerType,
                  filterableByYear: selectedEntity.filterableByYear,
                });

                toast.success('Household member has been selected');
              }}
            >
              <ListItem
                variant={id === currentTokenId ? 'selected' : 'inactive'}
                icon="far fa-check"
              >
                {name}
              </ListItem>
            </MenuItem>
          ))}

          <MenuSeparator />

          <MenuItem
            onSelect={() => {
              if (!selectedEntity) {
                return;
              }

              setSelectedEntity({ ...selectedEntity, forceUserAuthentication: true });
            }}
          >
            <ListItem icon="fas fa-plus">New Household Member</ListItem>
          </MenuItem>
        </MenuContent>
      </Menu>
    </>
  );
};
